// Generated by CoffeeScript 2.7.0
var Admin__UserProfile__SchemasController;

import ProfilesForm from "trunks/vue/admin/components/organizations/users_organizations_container/user_profile/form.js";

export default Admin__UserProfile__SchemasController = class Admin__UserProfile__SchemasController extends Skylark.App.BaseController {
  show() {
    var el, fields, form, ref;
    fields = (ref = this.getVars('schema')) != null ? ref.fields : void 0;
    form = new Skylark.App.Model.Form({
      title: '未命名表单',
      description: '',
      fields: fields,
      settings: {
        register_writed: false,
        explicit: false,
        enable_modify: true,
        layout: null,
        input_type: null,
        button_name: null
      },
      attachments: []
    });
    el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('user_profiles_edit');
    return new ProfilesForm({
      el: el,
      data: {
        form: form
      }
    });
  }

};
